import React, { useState } from "react"

import { useHistory } from "react-router-dom"
import { gql, useQuery } from "urql"

import { path } from "~Tutor/TutorRoutes"
import { StyledLink, WithLoadingIndicator } from "~tailwindui/Basics"
import Table from "~tailwindui/Table/Table"

import titlecase from "src/titlecase"

import LocalTime from "components/LocalTime"

export type PastSessionsProps = {
  studyGroupId: string
}

const PastSessions: React.FC<PastSessionsProps> = ({ studyGroupId }) => {
  const history = useHistory()
  const [page, setPage] = useState(1)
  const [result] = useQuery({
    query,
    variables: { studyGroupId, page },
  })

  return (
    <WithLoadingIndicator result={result}>
      {({ data: { viewer } }) => (
        <Table
          title="Past Sessions"
          data={viewer.pastGroupSessions}
          rowCallback={({ id }) => {
            history.push(path("sessionDetails", { id }))
          }}
          changePage={setPage}
          cols={[
            {
              header: "Date",
              value: session => (
                <span key={session.id} className="flex items-center">
                  <div key={session.id} className="min-w-[80px]">
                    <LocalTime
                      format="ddd MMM D, YYYY"
                      timestamp={session.startsAt}
                    />
                    <br />
                    <LocalTime omitDate timestamp={session.startsAt} />
                    &mdash;
                    <LocalTime omitDate timestamp={session.endsAt} />
                  </div>
                </span>
              ),
            },
            { header: "Subject", value: session => session.subject.name },
            {
              header: "Students",
              value: session => (
                <ul key={session.id}>
                  {session.students.map(student => (
                    <li className="flex items-center" key={student.id}>
                      <div>
                        <StyledLink
                          to={path("studentDetails", {
                            id: student.id,
                          })}
                        >
                          {student.fullName}
                        </StyledLink>
                      </div>
                    </li>
                  ))}
                </ul>
              ),
            },
            {
              header: "State",
              value: session => (
                <span key={session.id}>
                  {titlecase(session.statusState)} |{" "}
                  {titlecase(session.billState)}
                </span>
              ),
            },
          ]}
        />
      )}
    </WithLoadingIndicator>
  )
}

const query = gql`
  query StudyGroupPastSessions($studyGroupId: ID!, $page: Int) {
    viewer {
      pastGroupSessions: sessions(
        filters: { past: true, studyGroupIds: [$studyGroupId] }
        page: $page
      ) {
        currentPage
        totalPages
        data {
          id
          startsAt
          endsAt
          statusState
          billState
          subject {
            id
            name
          }
          students {
            id
            fullName
          }
        }
      }
    }
  }
`

export default PastSessions
